import React from "react";
import "./header.css";

const Header = () => {
  return (
    <div className="header">
      <h2>RizzQuiz</h2>
    </div>
  );
};

export default Header;
